<template>
    <layout-portal>     
        <!--Section: About-->
        <section class="about-page">
            <div class="row no-gutters">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col">
                            <p class="">O cityhub.pt é a Plataforma Centralizadora de Soluções Digitais que, através do elemento comum localização, permite ao munícipe aceder a serviços sem sair de casa e ao município garantir a prestação de serviços à população com melhor qualidade e celeridade.</p>                                                                
                        </div>
                    </div>
                    <div class="row align-items-sm-center">
                        <div class="col-10 col-sm-auto mx-auto mr-sm-4">
                            <img :src="assetsPathModule('/pic-about-1.png')" class="img-fluid">
                        </div>
                        <div class="col-12 col-sm">
                            <p class="">Beneficia de um design e conjunto de estilos que é comum à plataforma e às soluções que a integram, por forma a que a navegação seja fácil, entendida por todos os intervenientes e alargada aos diversos municípios do país, numa experiência intuitiva, acessível a Todos e para Todos.</p>
                            <p class="">Escalável em função das necessidades de cada município e da complexidade das suas operações diárias, o cityhub.pt é direto, prático, operacional e funcional. Os serviços são mostrados de imediato, os nomes correspondem à funcionalidade, a iconografia demonstra a utilidade.</p>

                        </div>                            
                    </div>
                    <div class="row highlight">
                        <div class="col-12 col-sm">
                            <div class="title mb-4">Vantagens para o Município</div>
                            <ul class="list-style">
                                <li>Disponibilizar um único ponto de contacto ao cidadão, com um design comum aos mais diversos serviços on-line</li>
                                <li>Disponibilizar um único ponto de contacto às unidades orgânicas, com um design comum às diversas soluções aplicacionais</li>
                                <li>Manter o contacto com o cidadão através do seu login e perfil, estreitando a comunicação, emitindo inquéritos direcionados, auscultando</li>
                                <li>Estabelecer uma gestão de equipas mais assertiva, com o login e perfil dos seus funcionários</li>
                                <li>Beneficiar da utilização das mais avançadas Tecnologias de Informação Geográfica para gerir o seu território com base no espaço, na localização</li>
                                <li>Beneficiar de uma plataforma que é extensível a outros territórios, exponenciando a experiência ao território nacional</li>
                            </ul>
                        </div>
                        <div class="col-12 col-sm-auto mb-0 ml-sm-4 d-flex align-items-center justify-content-center justify-content-sm-end">
                            <img :src="assetsPathModule('/pic-about-2.png')" class="img-fluid">
                        </div>
                    </div>
                    <div class="row">
                            <div class="col-12 col-sm-auto order-2 order-sm-1 mr-sm-4 d-flex align-items-center justify-content-center justify-content-sm-end">
                                <img :src="assetsPathModule('/pic-about-3.png')" class="img-fluid">
                            </div>
                            <div class="col-12 col-sm order-1 order-sm-2">
                                <div class="title mb-4">Vantagens para o Cidadão</div>
                                <ul class="list-style">
                                    <li>Aceder aos serviços através da sua localização, das suas propriedades, das suas pretensões</li>
                                    <li>Dispor de uma ferramenta de comunicação para enviar as suas sugestões e partilhar as preocupações ao Município</li>
                                    <li>Criar uma identidade sua através do login e perfil, passando a ter “passaporte” de munícipe, estando envolvido</li>
                                    <li>Manter-se protegido e usufruir da conveniência de evitar as deslocações e as filas nos serviços</li>
                                </ul>
                            </div>
                        </div>
                </div>
            </div>          

        </section>
        <!--Section: About-->
    </layout-portal>
</template>

<script>
import mixin from '../mixin'

export default {
    mixins: [mixin],
    data() 
    {
        return {
            pageTitle: 'Sobre',
        }
    },       
}

</script>

<style lang="scss">    
// @import "../style/about";
</style>